import { BaseContact, Loadable, LoadableStatus } from '@aiwyn/shared';
import {
  BaseClient,
  BaseFile,
  BaseJobServiceLine,
  ClientRequestDetails,
  ClientRequestGroupModel,
  ClientRequestMetadataModel,
  ClientRequestModel,
  DeliverableModel,
  QuestionnaireResponse,
  StaffEntity,
} from '@aiwyn/api';

export interface CommonClientRequestsStateModel {
  groups: Loadable<ClientRequestGroupModel>[];
  requests: Loadable<ClientRequestModel>[];
  details: Loadable<ClientRequestDetails>[];
  metadata: Loadable<ClientRequestMetadataModel>[];
  questionnaireResponses: Loadable<QuestionnaireResponse[]>;

  assignees: Loadable<BaseContact>[];
  staff: Loadable<StaffEntity>[];
  clients: Loadable<BaseClient>[];
  serviceLines: Loadable<BaseJobServiceLine>[];
  deliverables: Loadable<DeliverableModel>[];
  files: Loadable<BaseFile>[];
}

export const DEFAULT_COMMON_CLIENT_REQUESTS_STATE: CommonClientRequestsStateModel = {
  groups: [],
  requests: [],
  details: [],
  metadata: [],
  questionnaireResponses: { status: LoadableStatus.DEFAULT },

  clients: [],
  assignees: [],
  staff: [],
  serviceLines: [],
  deliverables: [],
  files: [],
};
